module.exports = __webpack_public_path__ + "img/snpark_gallery1.5f2bdf10.jpg";